module.exports = __webpack_public_path__ + "static/06-fz-c46cbec4ea97714b7c9ebd5868a2cdea.jpg";